<template>
  <div class="container">
    <div id="image_area">
      <img :src="takeOutImagePath" alt="" />
    </div>
    <div id="title">
      <span
        >ネットで事前注文して<br />店頭でラクラク受け取り♪<br />テイクアウトのご注文はこちらから</span
      >
    </div>
    <div id="description">
      <span
        >※一部店舗ではテイクアウト販売を行っておりません。<br />※一部店舗および沖縄県内の店舗では、<br />販売商品・販売価格が異なります。</span
      >
    </div>
    <div class="btn_area" @click="openWebOrder">
      <div class="image">
        <img src="@/assets/img/takeout/orderbtn.png" alt="" />
      </div>
    </div>
    <div class="btn_area" @click="showUsage">
      <div class="image">
        <img src="@/assets/img/takeout/notesbtn.png" alt="" />
      </div>
    </div>
    <template v-if="this.isUseAlert">
      <Usage @close="() => tapClose()" />
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'
import Usage from '../components/Modal/Usage.vue'
import DateFormatter from '../utils/DateFormatter.js'
import APIClient, { ErrorCode } from '../api/APIClient'
export default {
  name: 'TakeOut',
  components: {
    Usage
  },
  created() {
    document.title = 'ネット注文'
    const accTime = new DateFormatter().format(new Date())
    this.fetchTakeOutImage(accTime)
  },
  data() {
    return {
      title: 'ネット注文',
      webOrderUrl: process.env.VUE_APP_JOYNET_ENDPOINT,
      homeUri: 'frbbscreen://home',
      storeSearchUri: 'frbbscreen://search',
      takeOutImagePath: '',
      isUseAlert: false
    }
  },
  methods: {
    ...mapActions('Native', [
      'actionRequestToken',
      'actionRequestExternalLink'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Modal', ['action_ToggleModal']),
    openWebOrder() {
      this.trackEvent(FactoryTrack.createWebOrder())
      this.actionRequestExternalLink(this.webOrderUrl)
      // FIXME: Android 版 6.2.0 で token が返却されない問題があるため、強制アップデートで 6.2.0 以下のアプリを利用するユーザーがいなくなるまでは Joynet に userId を連携できない
      // 以上の問題を回避するため、NativeApp を経由せず userId を含まない素の URL で Joynet へ遷移する
      //
      // const accTime = new DateFormatter().format(new Date())
      // window.receivedToken = async payload => {
      //   window.receivedToken = null
      //   const json = JSON.parse(payload)
      //   await this.encryptUserId(json.user_id, accTime)
      // }
      // this.actionRequestToken({ apiType: '3', acc_time: accTime })
    },
    async encryptUserId(userId, accTime) {
      const res = await APIClient.postEncryptedUserId(userId, accTime)
      let url = this.webOrderUrl
      if (userId != null && res.status === 200 && res.data.url.length > 0) {
        url = res.data.url
      }
      this.actionRequestExternalLink(url)
    },
    openStoreSearch() {
      this.actionRequestExternalLink(this.webOrderUrl)
    },
    showUsage() {
      this.trackEvent(FactoryTrack.createShowUsage())
      this.action_ToggleModal(true)
      this.isUseAlert = true
    },
    tapClose() {
      this.action_ToggleModal(false)
      this.isUseAlert = false
    },
    async fetchTakeOutImage(accTime) {
      const res = await APIClient.postFetchTakeOutImage(accTime)
      if (
        res.status === 200 &&
        res.data.data.code === ErrorCode.CODE_SUCCESS &&
        res.data.data.takeout_image.length > 0
      ) {
        this.takeOutImagePath = res.data.data.takeout_image
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  background-color: #ffffff;

  #image_area {
    width: 100%;
    height: auto;
  }

  #image_area img {
    width: 100%;
    height: auto;
  }

  #title {
    width: 100%;
    margin-top: 20px;
    display: flex;
    white-space: nowrap;
    align-items: center;
    line-height: 26px;
    font-weight: bold;
    font-size: 16px;
    color: rgba(90, 34, 0, 1);
  }

  #title span {
    width: 100%;
  }

  #description {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 30px;
    align-items: center;
    display: flex;
    line-height: 21px;
    text-align: center;
    font-weight: normal;
    font-size: 12px;
    color: rgba(34, 34, 34, 1);
  }

  #description span {
    width: 100%;
  }

  .btn_area {
    width: 100%;
    padding-left: 15px;
    padding-top: 0px;
    padding-bottom: 15px;
  }

  .btn_area .image {
    width: 95%;
    align-items: center;
  }

  .btn_area .image img {
    width: 100%;
  }
}
</style>
